export default __webpack_public_path__ + "static/media/Household_Inventory_Items_page.b51e3fec.pdf";